import { API, Storage } from 'aws-amplify';

// @ts-ignore
export const create = async (post, commentText) => API.put(
  'robinhoodEngModeratorApi',
  `/comments/${post.id}`,
  { body: { commentText } },
);

// @ts-ignore
export const del = async (comment) => API.del('robinhoodEngModeratorApi', `/comments/${comment.id}`, {});
